export default __webpack_public_path__ + "static/partners-title-presenting-1245e08c4c19d6eb0d806bf160ef25f5.svg";